import React, { Fragment, Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators, compose } from "redux"
import { withRouter } from "react-router-dom"
import Modal from "react-modal"
import parse from "html-react-parser"

import Button from "components/common/Button"

import "styles/components/common/affirmation-modal.scss"
import CheckBox from "../checkbox"

class StatementModal extends Component {
  constructor() {
    super()

    this.state = {
      isChecked: false,
    }
  }

  confirmToggle = () => {
    this.setState({
      isChecked: !this.state.isChecked,
    })
  }

  handleConfirm = () => {
    const { onConfirm = false } = this.props

    this.setState(
      {
        isChecked: false,
      },
      () => {
        if (onConfirm) {
          onConfirm()
        }
      }
    )
  }

  handleClose = () => {
    const { closeModal = false } = this.props

    this.setState(
      {
        isChecked: false,
      },
      () => {
        if (closeModal) {
          closeModal()
        }
      }
    )
  }

  render() {
    const { isOpen, message = "", title, consentLabel } = this.props

    const { isChecked } = this.state

    return (
      <Modal
        closeTimeoutMS={1000}
        isOpen={isOpen}
        onRequestClose={() => this.handleClose()}
        ariaHideApp={false}
        className="affirmation-modal"
        overlayClassName="modal-overlay"
      >
        <Fragment>
          <div className="modal-container">
            <span className="modal-header">{title}</span>
            <p div className="modal-alert">
              Please scroll down to read the full statement then tick the
              checkbox at the bottom to signify your consent
            </p>
            <div className="modal-message">
              <div className="body-copy">{parse(message || "")}</div>
              <CheckBox
                text={consentLabel}
                checked={this.state.isChecked}
                onChange={this.confirmToggle}
                id="chk-statement-modal"
              />
            </div>
            <div className="row">
              <Button
                label="Continue"
                disabled={!isChecked}
                onClick={() => this.handleConfirm()}
              />
            </div>
          </div>
        </Fragment>
      </Modal>
    )
  }
}

const mapStateToProps = (state) => ({
  school: state.schoolReducer,
})

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch)

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter
)(StatementModal)
